export function createDriverAvailabilityClient(transport) {
    return {
        /**
         * The drivers an operator is looking at
         *
         * Requires scope: driver-availability:read, driver-availability:workload
         */
        getDriverAvailability(presence, availability, limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/driver-availability",
                query: { presence: presence, availability: availability, limit: limit, after: after },
                options,
            });
        },
        /**
         * Get effective availability and freshness
         *
         * Requires scope: driver-availability:read
         */
        getDriversAvailability(driverId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/availability`,
                options,
            });
        },
        /**
         * Set reasoned availability using optimistic concurrency
         *
         * Requires scope: driver-availability:write
         */
        postDriversAvailability(driverId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/availability`,
                body,
                options,
            });
        },
        /**
         * Start a server-issued online lease
         *
         * Requires scope: driver-availability:write
         */
        postDriversAvailabilityOnline(driverId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/availability/online`,
                body,
                options,
            });
        },
        /**
         * Extend the current fenced lease using server time
         *
         * Requires scope: driver-availability:heartbeat
         */
        postDriversAvailabilityHeartbeat(driverId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/availability/heartbeat`,
                body,
                options,
            });
        },
        /**
         * End the current lease with a reason code
         *
         * Requires scope: driver-availability:write
         */
        postDriversAvailabilityOffline(driverId, body, options) {
            return transport.request({
                method: "POST",
                path: `/v1/drivers/${encodeURIComponent(driverId)}/availability/offline`,
                body,
                options,
            });
        },
        /**
         * Hold a driver for one assignment, returning a fencing token
         *
         * Requires scope: driver-availability:claim
         */
        postAvailabilityClaims(body, options) {
            return transport.request({
                method: "POST",
                path: "/internal/v1/availability/claims",
                body,
                options,
            });
        },
        /**
         * Release a held driver, proving the hold with its fencing token
         *
         * Requires scope: driver-availability:claim
         */
        postAvailabilityClaimsRelease(claimId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/availability/claims/${encodeURIComponent(claimId)}/release`,
                body,
                options,
            });
        },
        /**
         * Return drivers held by callers that never came back
         *
         * Requires scope: driver-availability:claim
         */
        postAvailabilityClaimsExpireDue(options) {
            return transport.request({
                method: "POST",
                path: "/internal/v1/availability/claims/expire-due",
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=driver-availability.js.map